import { connect } from "react-redux";
import OnboardingWrapper from "./OnboardingWrapper";

import { getOrganizationPlans } from "../Organization/OrganizationActions";
import {
  checkOnboardingStatus,
  completeOnboarding,
  clearOnboardingFlags,
  resetOnboardingState,
} from "./onboardingNewActions";

// Export OnboardingWrapper as default (recommended usage)
const mapStateToProps = (state) => ({
  onboardingState: state.onboardingNew,
  profileState: state.profile,
  subscriptionPlans: state.organization.allPlans,
});

const mapDispatchToProps = {
  getOrganizationPlans,
  checkOnboardingStatus,
  completeOnboarding,
  clearOnboardingFlags,
  resetOnboardingState,
};

// Export connected OnboardingWrapper as default
export default connect(mapStateToProps, mapDispatchToProps)(OnboardingWrapper);
